/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'
import { Global } from '@emotion/react'
import global from './global.js'

const GlobalStyles = () => <Global styles={global} />

export default GlobalStyles
